<template>
    <v-container class="docfile-container">

        <v-layout row justify-center>
            <v-dialog v-model="isLoading" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
                <v-layout row justify-center align-center>
                <v-progress-circular :rotate="90" :value="progressValue"
                    :size="200" :width="20" color="pink">
                    </v-progress-circular>
                </v-layout>
            </v-container>
            </v-dialog>
        </v-layout>

        <v-layout column>
            <v-flex >
                <v-layout row>

                    <v-flex style="margin-left:20px;">
                        <h3>Upload Files</h3>
                    </v-flex>
                    <v-flex>
                        <input type="file" style="display:none" ref="fileInput" accept="*/*"
                            @change="onFilePicked">
                    </v-flex>
                    <v-flex shrink>
                        <v-btn
                            dark small
                            color="pink"
                            @click="onPickFile"
                            fab
                            class="ml-2"
                            >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>

                    </v-flex>
                    <v-flex shrink>
                        <v-btn
                            dark small
                            color="pink"
                            @click="fetchIssueFiles"
                            fab
                            class="mx-2"
                            >
                            <v-icon>refresh</v-icon>
                        </v-btn>

                    </v-flex>

                </v-layout>

            </v-flex>
            <v-flex>

                <v-layout row wrap>

                    <v-flex v-for="issueFile in issueFiles" :key="issueFile.id"
                        @click.prevent="openUrl(issueFile)" shrink mx-5>

                        <img :src="getFileIcon(issueFile)"   class="file-thumb" />        
            
                    </v-flex>


                </v-layout>

            </v-flex>
        </v-layout>

    </v-container>    
</template>
<script>

const fb = require('../../firebaseConfig.js')
export default {
    props:['issue'],
    data(){
        return {
            issueFile:null,
            issueFiles:[],
            progressValue:0,
            disabledBtns:false,
            isLoading: false,
            dialog: false,
            icons:{
                excel: require('../../assets/excel-icon.png'),
                word: require('../../assets/word-icon.png'),
                pdf: require('../../assets/pdf-icon.png'),
                mindmap: require('../../assets/mindmap-icon.png')
            }


        }
    },
    methods:{

        onPickFile(){
            this.$refs.fileInput.click()
        },
        onFilePicked(event){

            const files = event.target.files
            //console.log("files",files[0])
            let filename = files[0].name
            if (filename.lastIndexOf('.') <= 0){
                return alert('Please add a valid file')
            }
            this.issueFile = files[0]

            this.saveFile();

        },
        saveFile(){

            if (!this.issue){
                return;
            }

            if (!this.issueFile){
              return;
            }
            
            let dateId = this.getDateId();

            let filename = this.issueFile.name;   
            const filenameSplit = filename.split('.');
            let ext = filenameSplit.pop().toLowerCase();

            let fileType = "";

            if (ext.includes('xls')){
                fileType  = "Excel";
            }else if ( ext.includes('doc') ){
                fileType = "Word"
            }else if ( ext.includes('jpg') || ext.includes('jpeg') 
                || ext.includes('png') ){
                fileType = "Photo"
            }else if ( ext.includes('mp4') ){
                fileType = "Video"
            }else if ( ext.includes('mp3') ){
                fileType = "Audio"
            }else if ( ext.includes('pdf') ){
                fileType = "pdf"
            }else if ( ext.includes('mmap') ){
                fileType = "MindMap"
            }

            //console.log("ext",ext);
            //console.log("fileType",fileType);

            fb.issueFilesCollection.add({
                issueID: this.issue.issueID,
                issueKey:this.issue.id,
                fileName: this.issueFile.name,
                fileExtension: ext,
                fileType:fileType,
                fileUrl:'',
                thumbUrl:'',
                dateID: dateId,
                creationDate: new Date(),
            })
            .then(docRef=>{
                console.log("docRef",docRef.id);
                if (this.issueFile){
                  console.log("here in upload!!")
                  this.uploadFile( docRef.id  )
                }
                //this.$router.push({name:'itemlist'})
            })
            .catch(error=>console.log(error))

        },
        uploadFile( id ){

            //console.log("this.issueFile",this.issueFile)
            this.isLoading = true;
            this.progressValue = 10;
            this.disabledBtns = true;
            let ref = fb.storage.ref().child('issueFiles')

            let data = {
              etag: id,
              customMetadata: {
                  'imageId': id,
                  'fileName': this.issueFile.name,
                  'collection':'issueFiles'
                }  
            };

            var uploadTask = ref.child(this.issueFile.name).put(this.issueFile,data);

            var self = this;

            uploadTask.on('state_changed',function(snapshot){

              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              //console.log('Upload is ' + progress + '% done');
              self.progressValue = Math.round(progress);

            },function(error){
              console.log(error.message);
              this.disabledBtns = false;

            },function(){

              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
                //his.downloadURL = downloadURL;
                //console.log("this.downloadURL",downloadURL);
                
                fb.issueFilesCollection.doc(id).update({
                  fileUrl:downloadURL,
                  thumbUrl:''
                })

                self.isLoading = false;
                //self.$emit('close',{finished:true});
                self.forceRefreshFiles = true;
                setTimeout(()=>{
                    self.fetchIssueFiles();
                },2500);

              });
            });


        },
        fetchIssueFiles(){

            let issueFiles = [];
            fb.issueFilesCollection.where("issueKey","==",this.issue.id).get()
            .then(docIssueFiles=>{
                //console.log("issueFiles",issueFiles)
                docIssueFiles.forEach(issueFile=>{
                    //console.log("issueFile",issueFile.data());
                    const data = {
                        'id':issueFile.id,
                        'issueID':issueFile.issueID,
                        'issueKey': issueFile.data().issueKey,
                        'fileName':issueFile.data().fileName,
                        'fileType':issueFile.data().fileType,
                        'fileExtension':issueFile.data().fileExtension,
                        'fileUrl':issueFile.data().fileUrl,
                        'thumbUrl':issueFile.data().thumbUrl,
                        'creationDate':issueFile.data().creationDate.toDate(),
                    }
                    issueFiles.push(data);
                });
                
                /*
                let sortedissueFiles = issueFiles.sort(function(a,b){
                    //return b.docFileId - a.docFileId
                    return a.fileName - b.fileName
                });
                */

                issueFiles.sort((a,b)=>(a.fileName > b.fileName) ? 1 : -1);

                //console.log("fresh issueFiles",sortedissueFiles)
                this.issueFiles = issueFiles;

            })
        },
       
        getDateId(){

          let dateId = ''
            
          let currentDate = new Date()
          let hours = currentDate.getHours();
          if (hours < 12){
              currentDate.setDate(currentDate.getDate()-1)
          }
          //console.log("currentDate",currentDate);

          dateId  = currentDate.getFullYear() + '' 
              + ( (currentDate.getMonth() + 1) < 10 ? '0'+ (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1) ) 
              + ( currentDate.getDate() < 10 ? '0'+ currentDate.getDate()  : currentDate.getDate() ) 
          
          return dateId;

        },
        getFileIcon(f){
            if (f.fileType == 'Excel'){
                return this.icons.excel;
            }else if (f.fileType == 'Word'){
                return this.icons.word;
            }else if (f.fileType == 'Photo') {
                return f.thumbUrl
            }else if (f.fileType == 'Video') {
                return f.thumbUrl
            }
            else if (f.fileType == 'pdf') {
                return this.icons.pdf
            }else if (f.fileType == 'MindMap') {
                return this.icons.mindmap
            }else{
                return this.icons.excel;
            }
        },
        isFileLink(f){
            if (f.fileType == 'Excel' || f.fileType == 'Word'
                || f.fileType == 'pdf' ){
                return true;
            }else{
                return false;
            }

        },
        openUrl(issueFile){
            window.open(issueFile.fileUrl, "_blank");   
        },

    },
    mounted(){
        console.log("Mounted IssueFiles");
        this.fetchIssueFiles();
    }
    
}
</script>
<style scoped>
.docfile-container{
    margin-top: 10px;
    margin-bottom: 10px;
    min-width: 300px;
    min-height: 300px;
    width: 100%;
    list-style-type: none;
    background: white;
    border-radius: 10px;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.1);
    cursor: pointer;
}
.file-icon{
    width:60px;
    height: 60px;
    max-width: 60px;
    max-height: 60px;
}

.file-thumb{
    width:120px;
    height: 120px;
    max-width: 120px;
    max-height: 120px;
    border-radius: 5px;
}

</style>